import { render, staticRenderFns } from "./notifySettingList.vue?vue&type=template&id=122e36b4&scoped=true"
import script from "./notifySettingList.vue?vue&type=script&lang=js"
export * from "./notifySettingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122e36b4",
  null
  
)

export default component.exports